import HttpRequest from "./HttpRequest";

export default class RedirectService {

  httpRequest = new HttpRequest();

  static goToAuth() {
    const currentUrl = window.location;
    window.location = '/accounts#?redirectTo=' + currentUrl;
  }

}



// WEBPACK FOOTER //
// ./src/services/RedirectService.js